export const environment = {
    production: false,
    instagram_token: 'INSTA_TOKEN',
    stripe_token: 'pk_test_51IedeFIydQG8egZ1hGi0VOz0H6xVOKmW4bHfJvVMiUvi4aAMtNZWo0JutVL0KOYbvZXQlmrukMqpQSvBuCBa2bhR00t3Pp4z9y',
    paypal_token: 'PAYPAL_TOKEN',
    paramUrlBase: "",
    srcImg:  "/media/images/",
    srcProducts:  "/media/products/"
  };
  